<template>
  <div>
    <v-toolbar color="page-toolbar">
      <v-icon class="mr-8" @click="$router.push({ name: 'admin-user-list' })" title="Retour à la liste des utilisateurs"
        >mdi-arrow-left</v-icon
      >
      <v-toolbar-title class="text-body-large" v-if="user.uid">
        Modifier un utilisateur <small>(Administration)</small>
      </v-toolbar-title>
      <v-toolbar-title class="text-body-large" v-else>
        Ajouter un utilisateur <small>(Administration)</small>
      </v-toolbar-title>
    </v-toolbar>
    <v-form>
      <v-container>
        <h1>Information sur l'utilisateur</h1>
        <v-alert v-if="userInfoSuccessMessage" type="success" density="compact" class="mb-4">
          {{ userInfoSuccessMessage }}
        </v-alert>
        <div v-if="isLoadingUserInfo" class="loading-state">
          <v-progress-circular indeterminate color="primary" size="36" width="4"></v-progress-circular>
          <p>Chargement des informations utilisateur...</p>
        </div>
        <v-row v-else class="mb-3" no-gutters>
          <v-col md="6">
            <v-text-field v-model="user.displayName" label="Nom" required></v-text-field>
            <div v-if="user.uid">
              <p>{{ user.email }}</p>
              <p>{{ user.uid }}</p>
            </div>
            <div v-else>
              <v-text-field v-model="user.email" label="Email" required></v-text-field>
            </div>
            <v-switch v-model="user.disabled" label="Désactiver" color="red-darken-3"></v-switch>
            <v-btn
              variant="flat"
              color="primary"
              @click="saveUserInfo(user)"
              :loading="isSavingUser"
              :disabled="isSavingUser"
              v-if="user.uid"
            >
              <v-icon>mdi-account-edit</v-icon>
              &nbsp; Modifier les informations utilisateur
            </v-btn>
            <v-btn
              variant="flat"
              color="primary"
              @click="addUserInfo(user)"
              :loading="isSavingUser"
              :disabled="isSavingUser"
              v-else
            >
              <v-icon>mdi-account-plus</v-icon>
              &nbsp; Ajouter l'utilisateur
            </v-btn>
          </v-col>
          <v-col md="6"> </v-col>
        </v-row>
        <br />
        <v-divider></v-divider>
        <br />
        <div v-if="isEditingExistingUser">
          <h1>Information sur l'abonnement</h1>
          <v-alert v-if="membershipSuccessMessage" type="success" density="compact" class="mb-4">
            {{ membershipSuccessMessage }}
          </v-alert>
          <div v-if="isLoadingMembership" class="loading-state">
            <v-progress-circular indeterminate color="primary" size="36" width="4"></v-progress-circular>
            <p>Chargement des informations d'abonnement...</p>
          </div>
          <v-row v-else class="mb-3" no-gutters>
            <v-col md="6">
              <h4>Type de membre</h4>
              <v-select v-model="userMembership.access" :items="membershipType"> </v-select>
              <div v-if="userMembership.access === 'member'">
                <v-date-input
                  :model-value="isoDateToDate(membershipEndDate)"
                  label="Date de fin de l'abonnement"
                  @update:model-value="membershipEndDate = dateToIsoDate($event)"
                ></v-date-input>
                <h4>Note</h4>
                <v-textarea
                  clearable
                  clear-icon="mdi-close-circle"
                  label="Raison si modification manuelle de l'abonnement"
                  v-model="userMembership.note"
                ></v-textarea>
              </div>
              <v-btn
                variant="flat"
                color="primary"
                @click="saveMembershipInfo(userMembership)"
                :loading="isSavingMembership"
                :disabled="isSavingMembership"
              >
                <v-icon>mdi-currency-usd</v-icon>
                Modifier les informations sur l'abonnement
              </v-btn>
            </v-col>
            <v-col md="6"> </v-col>
          </v-row>
        </div>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  import { /*auth,*/ functions } from "@/firebase";
  import { dateToIsoDate, isoDateToDate } from "@/utils/dates";
  import { notify } from "@/services/Notification.service";
  export default {
    data() {
      return {
        user: { uid: null, displayName: "", email: "" },
        userMembership: { id: null, access: "aucun", endDate: null, note: "" },
        membershipEndDate: "",
        membershipType: ["aucun", "member", "admin"],
        isLoadingUserInfo: false,
        isLoadingMembership: false,
        isSavingUser: false,
        isSavingMembership: false,
        userInfoSuccessMessage: "",
        membershipSuccessMessage: "",
        latestLoadId: 0,
      };
    },
    computed: {
      isEditingExistingUser() {
        return this.$route.params.slug && this.$route.params.slug !== "new";
      },
    },
    watch: {
      async "$route.params.slug"() {
        await this.loadUserInfo();
      },
    },
    async mounted() {
      await this.loadUserInfo();
    },
    methods: {
      dateToIsoDate,
      isoDateToDate,
      async loadUserInfo() {
        const uid = this.$route.params.slug;
        const loadId = ++this.latestLoadId;

        if (!uid || uid === "new") {
          this.user = { uid: null, displayName: "", email: "" };
          this.userMembership = { id: null, access: "aucun", endDate: null, note: "" };
          this.membershipEndDate = "";
          this.userInfoSuccessMessage = "";
          this.membershipSuccessMessage = "";
          this.isLoadingUserInfo = false;
          this.isLoadingMembership = false;
          return;
        }

        this.isLoadingUserInfo = true;
        this.isLoadingMembership = true;

        await Promise.all([
          this.getUserInfo(uid, loadId).finally(() => {
            if (loadId === this.latestLoadId) {
              this.isLoadingUserInfo = false;
            }
          }),
          this.getUserMembership(uid, loadId).finally(() => {
            if (loadId === this.latestLoadId) {
              this.getDate(this.userMembership.endDate);
              this.isLoadingMembership = false;
            }
          }),
        ]);
      },
      async callCloudFunction(functionName, payload) {
        const cloudFunction = functions.httpsCallable(functionName);
        try {
          return await cloudFunction(payload);
        } catch (error) {
          return error;
        }
      },
      async getUserInfo(uid, loadId) {
        const user = await this.callCloudFunction("getUserByUid", { uid: uid });
        if (loadId !== this.latestLoadId) {
          return;
        }
        this.user = user.data || { uid: null, displayName: "", email: "" };
      },
      async addUserInfo(user) {
        this.isSavingUser = true;
        this.userInfoSuccessMessage = "";
        const userInfo = user;
        const saveUserInfo = await this.callCloudFunction("updateUserInfo", { userData: userInfo });
        this.isSavingUser = false;

        const savedUid = this.getSavedUserUid(saveUserInfo);
        if (!savedUid) {
          return saveUserInfo;
        }

        this.userInfoSuccessMessage = "Informations utilisateur mises à jour avec succès.";
        notify("Informations utilisateur mises à jour.");

        const slug = savedUid;
        this.$router.push({ name: "admin-user-edit", params: { slug: slug, user: saveUserInfo.data } });
      },
      async saveUserInfo(user) {
        this.isSavingUser = true;
        this.userInfoSuccessMessage = "";
        const userInfo = user;
        const saveUserInfo = await this.callCloudFunction("updateUserInfo", { userData: userInfo });
        this.isSavingUser = false;

        if (this.getSavedUserUid(saveUserInfo)) {
          this.userInfoSuccessMessage = "Informations utilisateur mises à jour avec succès.";
          notify("Informations utilisateur mises à jour.");
        }

        return saveUserInfo;
      },
      getSavedUserUid(saveUserInfo) {
        if (!saveUserInfo || !saveUserInfo.data) {
          return null;
        }

        if (saveUserInfo.data.uid) {
          return saveUserInfo.data.uid;
        }

        if (saveUserInfo.data.data && saveUserInfo.data.data.uid) {
          return saveUserInfo.data.data.uid;
        }

        return null;
      },
      async getUserMembership(uid, loadId) {
        const userMembership = await this.callCloudFunction("getUserMembershipByUid", { uid: uid });

        if (loadId !== this.latestLoadId) {
          return;
        }

        if (userMembership.data) {
          this.userMembership = userMembership.data;
        } else {
          this.userMembership = { id: uid, access: "aucun", endDate: null, note: "" };
        }
      },
      async saveMembershipInfo(userMembershipInfo) {
        this.isSavingMembership = true;
        this.membershipSuccessMessage = "";
        if (userMembershipInfo.access == "member") {
          userMembershipInfo.endDate = this.setDate(this.membershipEndDate);
        }
        const userMembership = await this.callCloudFunction("setUserMembership", { userRole: userMembershipInfo });
        this.isSavingMembership = false;

        if (userMembership && userMembership.data) {
          this.membershipSuccessMessage = "Informations d'abonnement mises à jour avec succès.";
          notify("Informations d'abonnement mises à jour.");
        }

        return userMembership;
      },
      getDate(unixDate) {
        // Convert timestamp to milliseconds
        if (unixDate) {
          var date = new Date(unixDate * 1000);

          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          var zero = month < 10 ? "0" : "";

          var convdataTime = year + "-" + zero + month + "-" + day;

          this.membershipEndDate = convdataTime;
        }
      },
      setDate(date) {
        var unixDate = 0;
        if (date) {
          unixDate = Math.floor(new Date(date).getTime() / 1000);
        }
        return unixDate;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .loading-state {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 56px;
  }

  .loading-state p {
    margin: 0;
  }
</style>
